import { categories } from '@/mocks/categories';

export default function Footer() {
  const categoryGroups = [
    categories.slice(0, 5),
    categories.slice(5, 10),
    categories.slice(10, 14),
  ];

  const groupTitles = ['Categorias Populares', 'Mais Categorias', 'Outras Categorias'];

  return (
    <footer className="relative bg-primary-700 text-background-200 pt-14 md:pt-20 pb-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Top: Brand */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10 md:mb-14 gap-4">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-xl font-semibold text-background-50 tracking-tight">
              hoobuy<span className="text-accent-400">.website</span>
            </span>
          </a>
          <p className="text-background-300 text-sm max-w-md leading-relaxed">
            Seu guia completo para compras internacionais inteligentes com o Hoobuy Spreadsheet.
          </p>
        </div>

        {/* Middle: Link Groups */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10 md:mb-14">
          {groupTitles.map((title, groupIndex) => (
            <div key={title}>
              <h4 className="font-semibold text-background-50 text-sm mb-4 whitespace-nowrap">
                <a href="#categories" className="cursor-pointer hover:text-accent-400 transition-colors">{title}</a>
              </h4>
              <ul className="space-y-2.5">
                {categoryGroups[groupIndex].map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-background-300 text-sm hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.namePt}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* 4th column: Article + Social */}
          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-4 whitespace-nowrap">
              Conteúdo
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="/artigo/guia-completo-hoobuyspreadsheet"
                  className="text-background-300 text-sm hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Guia Completo
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-300 text-sm hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  hoobuy sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-300 text-sm hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  buy it now
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-primary-500 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-heading text-lg text-background-50 italic">
            &copy; hoobuy.website 2026
          </p>
          <p className="text-background-300 text-sm">
            All rights reserved
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-300 text-sm underline hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              Twitter
            </a>
            <a href="#" className="text-background-300 text-sm underline hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              Instagram
            </a>
            <a href="#" className="text-background-300 text-sm underline hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              Pinterest
            </a>
            <a href="#" className="text-background-300 text-sm underline hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              TikTok
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}